<template>
  <div class="checkbox-input">
    <div class="form-group row">
      <label v-if="options.label" :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <div class="checkbox mt-2">
          <label class="switch">
            <input type="checkbox"
              :id="options.name"
              :checked="value"
              :name="options.name"
              @change="validate($event.target.checked)"/>
              <span class="slider round"></span>
          </label>
        </div>
        <div v-show="value && options.checkboxLabel" class="form-section-success" v-html="options.checkboxLabel"></div>
        <div v-show="!value && options.checkboxOffLabel" class="form-section-info" v-html="options.checkboxOffLabel"></div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'CheckboxInput',
  props: {
    value: {
      type: Boolean
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          checkboxLabel: '',
          required: false
        }
      }
    }
  },
  data () {
    return {
      isDirty: false,
      isValid: false,
      choices: false
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      return this.options.invalidMessage ? this.options.invalidMessage : 'Invalid value!'
    }
  },
  methods: {
    validate (val = this.value) {
      this.$emit('input', val)
      if (this.options.required) {
        this.isDirty = true
        this.isValid = val
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/CheckboxInput.vue